import { ProjectFilenameTemplateItem } from '../classes/ProjectFilenameTemplateItem'

export const ProjectName = new ProjectFilenameTemplateItem({
  id: '5f93d0a6-6f98-4ba7-88c3-bea286337f41',
  name: 'Project Name',
  property: 'projectName',
  help: 'Project Name from Projects table',
})

export const ClientProjectNumber = new ProjectFilenameTemplateItem({
  id: '3fe3ea43-a849-4c61-a695-ae2683ee9392',
  name: 'Project Number/Pin',
  property: 'clientProjectNumber',
  help: 'Client Project Number from Projects table',
})

export const ClientProjectName = new ProjectFilenameTemplateItem({
  id: 'dcabca28-3ccf-4679-9806-ce8a1877e6ff',
  name: 'Client Project Name',
  property: 'clientProjectName',
  help: 'Client Project Name from Projects table',
})

export type ProjectFilename =
  | typeof ProjectName
  | typeof ClientProjectNumber
  | typeof ClientProjectName
